import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "../components/auth/register/register";
import Login from "../components/auth/login";
import React, { useEffect } from "react";
import { getStorageValue, setStorageValue } from "../algorithms/storage";
import {
  changeDir,
  getCurrentLangFromRedux,
  getDir,
} from "../algorithms/styleChanges";
import Lang from "../userPreferences/staticWords";
import { useDispatch, useSelector } from "react-redux";
import { useJwt } from "react-jwt";
import {
  getUserData,
  isAuthentactedState,
  refreshUserToken,
} from "../API/store/actions/auth";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import TasksIndex from "../components/tasks/tasksIndex";
import TaskDetailsIndex from "../components/tasks/taskDetailsIndex";
import Test from "../components/layout/testComponents/test";
import Projects from "../components/projects/projectsIndex";
import Dashboard from "../components/dashboard/dashboard";
import WorkTeam from "../components/workTeam/workTeam";
import Files from "../components/files/files";
import DiscussionIndex from "../components/discussion/discussionIndex";
import ProjectDetailsIndex from "../components/projects/projectDetailsIndex";
import DiscussionDetails from "../components/discussion/discussionDetails";
import ActivityDetailsIndex from "../components/projects/activityDetailsIndex";
import UsersList from "../components/admin/userManage";
import CommunitiesList from "../components/admin/communityManage";
import CommunityDetails from "../components/community/communityDetails";
import ConfirmEmail from "../components/resetPassword/confirmEmail";
import ResetPassword from "../components/resetPassword/resetPassword";
import UserProfileIndex from "../components/userProfile/userProfileIndex";
import LookupsIndex from "../components/lookups/lookupsIndex";
import GuestProfileIndex from "../components/guestProfile/guestProfileIndex";
import MessengerIndex from "../components/userProfile/messages/messengerIndex";
import PostDetails from "../components/userProfile/posts/postDetails";
import SubTaskDetails from "../components/tasks/subTaskDetails";
import SubTaskDetailsIndex from "../components/tasks/subTaskDetailsIndex";
import HomePage from "./../components/homePage/homePage";
import NotifIcationIndex from "./../components/notifictions/notificationIndex";
import HomeIndex from "../components/HomeIndex";
import Axis from "../components/Axis/Axis";
import MemberChart from "../components/EntityAxis/EntityAxis";
import EntityAxis from "../components/EntityAxis/EntityAxis";
import EntityProcedures from "../components/layout/entityProcedure/Procedure";
import AgendaAndLinksIndex from "../components/AgendaAndLinks/AgendaAndLinksIndex";
import AgendaAndLinksManagment from "../components/AgendaAndLinks/AgendaAndLinksManagment";
import PresidentialAssignmentsList from "../components/PresidentialAssignments/PresidentialAssignmentsList";
import LinksManagment from "../components/AgendaAndLinks/LinksManagment";
import PresidentialDirectiveList from "../components/PresidentialAssignments/PresidentialDirectiveList";

const AppRouting = () => {
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const userLang = useSelector((state) => state.login.Lang);

  const { decodedToken, reEvaluateToken } = useJwt(userToken);
  const isExpired = Date.now() < decodedToken?.exp;
  useEffect(() => {
    if (isExpired) {
      refreshUserToken(userToken);
    }
    if (userToken && decodedToken && !isExpired) {
      dispatch(
        getUserData(
          decodedToken.UserId,
          isAuthentactedState,
          userToken,
          dispatch,
        ),
      );
    }
  }, [decodedToken, isExpired]);

  useEffect(() => {
    changeDir(getStorageValue("language") ?? "ar");
    Lang.setLanguage(getStorageValue("language") ?? "ar");
    setStorageValue(getStorageValue("language") ?? "ar");
  }, []);

  return (
    <div
      style={{ direction: getDir(getCurrentLangFromRedux()) }}
      className={`${
        getDir(getCurrentLangFromRedux()) == "rtl"
          ? "arabicFont"
          : "englishFont"
      }`}
    >
      <Router>
        <Routes>
          <Route exact path="/register" element={<Register />}></Route>
          <Route
            exact
            path="/"
            element={
              <PublicRoute>
                <HomeIndex />
              </PublicRoute>
            }
          ></Route>
          <Route
            exact
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          ></Route>
          <Route
            exact
            path="/confirmMail"
            element={
              <PublicRoute>
                <ConfirmEmail />
              </PublicRoute>
            }
          ></Route>
          <Route
            exact
            path="/resetpassword"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          ></Route>
          {/* <Route
            exact
            path="/nav"
            element={
              // <PrivateRoute>
              <MainNavbar />
              // </PrivateRoute>
            }
          ></Route> */}
          <Route
            exact
            path="/profile"
            element={
              <PrivateRoute haveSidebar={true}>
                <UserProfileIndex />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/homepage"
            element={
              <PrivateRoute haveSidebar={true}>
                <HomePage />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/homeindex"
            element={
              <PrivateRoute haveSidebar={true}>
                <HomePage />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/presidential-assignments"
            element={
              <PrivateRoute haveSidebar={true}>
                <PresidentialAssignmentsList />
              </PrivateRoute>
            }
          ></Route>{" "}
          <Route
            exact
            path="/presidential-assignments-directive/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <PresidentialDirectiveList />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/agendaAndlinks"
            element={<AgendaAndLinksIndex />}
          ></Route>
          <Route
            exact
            path="/agendaManagemnt"
            element={
              <PrivateRoute haveSidebar={true}>
                <AgendaAndLinksManagment />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/linksManagemnt"
            element={
              <PrivateRoute haveSidebar={true}>
                <LinksManagment />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/profile/:roomId"
            element={
              <PrivateRoute haveSidebar={true}>
                <UserProfileIndex tabId={"A7"} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/post/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <PostDetails />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/profile/:id/:memberId"
            element={
              <PrivateRoute haveSidebar={true}>
                <GuestProfileIndex />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/lookups"
            element={
              <PrivateRoute haveSidebar={true}>
                <LookupsIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/tasks/:userId"
            element={
              <PrivateRoute haveSidebar={true}>
                <TasksIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/tasks/communities/:communityId"
            element={
              <PrivateRoute haveSidebar={true}>
                <TasksIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/tasks/search/:taskStatusId"
            element={
              <PrivateRoute haveSidebar={true}>
                <TasksIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/discussion"
            element={
              <PrivateRoute haveSidebar={true}>
                <DiscussionIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/notificationsIndex"
            element={
              <PrivateRoute haveSidebar={true}>
                <NotifIcationIndex />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/discussion/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <DiscussionDetails userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/taskDetails/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <TaskDetailsIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/subTaskDetails/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <SubTaskDetailsIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/activityDetails/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <ActivityDetailsIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/projectDetails/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <ProjectDetailsIndex userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/communityDetails/:id"
            element={
              <PrivateRoute haveSidebar={false}>
                <CommunityDetails userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          {/* <Route
            exact
            path="/taskDetails/:searchKey/:id"
            element={
              <PrivateRoute haveSidebar={true}>
                <TaskDetailsIndex />
              </PrivateRoute>
            }
          ></Route> */}
          <Route
            exact
            path="/projects"
            element={
              <PrivateRoute haveSidebar={true}>
                <Projects userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/workTeam"
            element={
              <PrivateRoute haveSidebar={true}>
                <WorkTeam userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/axis"
            element={
              <PrivateRoute haveSidebar={true}>
                <Axis userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/entityAxis"
            element={
              <PrivateRoute haveSidebar={true}>
                <EntityAxis userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/files"
            element={
              <PrivateRoute haveSidebar={true}>
                <Files userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/admin"
            element={
              <PrivateRoute haveSidebar={true}>
                <UsersList userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/adminCommunity"
            element={
              <PrivateRoute haveSidebar={true}>
                <CommunitiesList userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute haveSidebar={true}>
                <Dashboard userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/procedures/:id/:name/:axisId"
            element={
              <PrivateRoute haveSidebar={true}>
                <EntityProcedures userToken={userToken} />
              </PrivateRoute>
            }
          ></Route>
          {/* <Route exact path="/test" element={<Test />}></Route> */}
          {/* <Route exact path="/nav" element={}></Route> */}
        </Routes>
      </Router>
    </div>
  );
};

export default AppRouting;

// const AnonymouseRouting = () => {
//   return (
//     <>
//       <Route exact path="/" element={<Register />}></Route>
//       <Route exact path="/login" element={<Login />}></Route>
//       <Route exact path="/nav" element={<MainNavbar />}></Route>
//     </>
//   );
// };
// const IdentityRouting = () => {
//   return (
//     <>
//       <Route exact path="/nav" element={<MainNavbar />}></Route>
//     </>
//   );
// };

// {
//   Authentacted ? (
//     <Route
//       exact
//       path="/login"
//       element={
//         <PrivateRoute isAuthenticated={isAuthentacted(userData?.status)}>
//           <Login />
//         </PrivateRoute>
//       }
//     ></Route>
//   ) : (
//     <Route exact path="/login" element={<Login />}></Route>
//   );
// }
